/* cym-dc.js — shared behaviour for the Cook Your Mood cloned page.
   Loaded by several sections; every initialiser is guarded so repeated
   <script src> tags bind exactly once. This runs page-wide, so it also
   drives sections that don't load it themselves. */
(function () {
  if (window.__cymdInit) return;
  window.__cymdInit = true;

  /* ---------- delegated AJAX add-to-cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cymd-atc]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-cymd-variant');
    if (!id) { window.location.href = '/cart'; return; }

    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function () {
        btn.innerHTML = original;
        btn.disabled = false;
        if (window.theme && typeof window.theme.openCartDrawer === 'function') {
          window.theme.openCartDrawer();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        setTimeout(function () {
          if (!document.querySelector('.cart-drawer.is-open, cart-drawer[open], .drawer--cart.active')) {
            window.location.href = '/cart';
          }
        }, 450);
      })
      .catch(function () {
        btn.innerHTML = original;
        btn.disabled = false;
        window.location.href = '/cart';
      });
  });

  /* ---------- sticky bar reveal (source: scrollY > 800) ---------- */
  function initSticky() {
    var bars = document.querySelectorAll('[data-cymd-sticky]');
    if (!bars.length) return;
    var onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var show = y > 800;
      bars.forEach(function (bar) { bar.classList.toggle('is-visible', show); });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- price reveal on scroll ----------
     Adds .is-in to every .cymd-price-row as it enters the viewport.
     Purely additive: without this the price still renders normally. */
  function initPriceReveal() {
    var rows = document.querySelectorAll('.cymd-price-row');
    if (!rows.length) return;

    if (!('IntersectionObserver' in window)) {
      rows.forEach(function (r) { r.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });

    rows.forEach(function (r) {
      if (!r.classList.contains('is-in')) io.observe(r);
    });
  }

  /* ---------- comparison tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-cymd-tabs]').forEach(function (group) {
      var tabs = group.querySelectorAll('[data-cymd-tab]');
      var titleEl = group.querySelector('[data-cymd-tab-title]');
      var rowsEl = group.querySelector('[data-cymd-tab-rows]');
      if (!tabs.length || !titleEl || !rowsEl) return;

      function activate(tab) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        titleEl.textContent = tab.getAttribute('data-cymd-title') || '';
        var rows = (tab.getAttribute('data-cymd-rows') || '').split('|').filter(Boolean);
        rowsEl.innerHTML = '';
        rows.forEach(function (r) {
          var d = document.createElement('div');
          d.className = 'cymd-row cymd-row-old';
          var mk = document.createElement('span');
          mk.className = 'cymd-mk';
          mk.textContent = '✕';
          var sp = document.createElement('span');
          sp.textContent = r;
          d.appendChild(mk); d.appendChild(sp);
          rowsEl.appendChild(d);
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab); });
      });
      activate(tabs[0]);
    });
  }

  function boot() { initSticky(); initTabs(); initPriceReveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initTabs(); initSticky(); initPriceReveal();
  });
})();
